/**
 * I6 — Gradient Mesh Hero (Lusion lite, Three.js 미사용)
 *
 * Hero 배경에 SVG `<feTurbulence>` + radial-gradient 두 색이 잔잔히 변형.
 * IntersectionObserver 로 viewport 안에 있을 때만 paint, 벗어나면 정지.
 *
 * 트리거: <div data-anim="gradient-mesh" class="ui-gradient-mesh">
 *           <svg class="ui-gradient-mesh__svg">...</svg>
 *         </div>
 *
 * 동작:
 *  • CSS @keyframes 로 turbulence baseFrequency 가 천천히 변하는 효과를 흉내
 *    (실제 baseFrequency SMIL/JS 애니메이션은 비싸서, blur+blob translate 로 대체)
 *  • paint 일시정지: IntersectionObserver 로 wrap 이 not intersecting 일 때 animation-play-state: paused
 *  • prefers-reduced-motion 시 정적 표시
 *
 * 가이드: plan §2.1 / §7.1 A-2c
 */

import { motionOK } from "./MotionTokens";

export class GradientMeshHero {
    private static observer: IntersectionObserver | null = null;

    static init(): void {
        const wraps = Array.from(
            document.querySelectorAll<HTMLElement>('[data-anim="gradient-mesh"]'),
        );
        if (!wraps.length) return;

        const reduced = !motionOK();

        if (reduced) {
            wraps.forEach((w) => {
                const blobs = w.querySelectorAll<HTMLElement>(".ui-gradient-mesh__blob");
                blobs.forEach((b) => {
                    b.style.animation = "none";
                });
            });
            return;
        }

        // 진입/이탈 시 paint 토글
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const blobs = entry.target.querySelectorAll<HTMLElement>(
                        ".ui-gradient-mesh__blob",
                    );
                    blobs.forEach((b) => {
                        b.style.animationPlayState = entry.isIntersecting ? "running" : "paused";
                    });
                });
            },
            { threshold: 0.01 },
        );

        wraps.forEach((w) => this.observer!.observe(w));
    }
}
